<script lang="ts">
  import { type JSONObject } from "../lib/dataform/dataFormLib.svelte";
  import RailsForm from "../components/Form.svelte";
  import DataForm from "../lib/dataform/DataForm.svelte";
  import Workflow from "../lib/workflow/Workflow.svelte";
  import Step from "../lib/workflow/Step.svelte";
  import ConsentStep from "./CheckboardConsentTask/ConsentStep.svelte";
  import FinancingAddressesStep from "./CheckboardConsentTask/FinancingAddressesStep.svelte";

  let {
    action,
    data,
    errors,
    checkboardLogo,
    kountLogo,
  }: {
    action: string;
    data: JSONObject;
    errors: JSONObject;
    checkboardLogo: string;
    kountLogo: string;
  } = $props();
</script>

<RailsForm method="put" {action} class="ui-rhythm">
  <DataForm name="account" {data} {errors}>
    <Workflow>
      <Step><ConsentStep {checkboardLogo} {kountLogo} /></Step>
      <Step><FinancingAddressesStep /></Step>
    </Workflow>
  </DataForm>
</RailsForm>
